module.exports = __webpack_public_path__ + "img/molecular genetics.71a2e620.jpg";